export function isMobileClient() {
  return matchMedia('(hover: none)').matches;
}
